module.exports = __webpack_public_path__ + "3c9aef750810d4f0c92f368cd9b89b4f.png";